import { ISelectOption } from '@common/components/forms';
import { IModel, Model } from '.';
import { MacroType } from './Enums/MacroType';

export interface IMacroTypeModel extends IModel {
  macroTypeId: number;
  name: string;
}

export class MacroTypeModel extends Model implements IMacroTypeModel {
  macroTypeId: number;
  name: string;

  constructor(params?: Partial<IMacroTypeModel>) {
    super(params);
    this.macroTypeId = _.defaultTo(params?.macroTypeId, 0);
    this.name = _.defaultTo(params?.name, '');
  }
}

export const macroTypes: ISelectOption[] = [
  { value: MacroType.Hospitals, label: 'Hospitals' },
  { value: MacroType.Location, label: 'Location' },
  { value: MacroType.Provider, label: 'Provider' },
];
